<template>
    <TheSkinSwiper :showSkinArticles="oilySkin" skinType="油性肌" />
</template>

<script setup>
import { ref } from 'vue';
import TheSkinSwiper from '@/components/widget/TheSkinSwiper.vue';
import data from '@/assets/data/oilySkin.json';

let oilySkin = ref(data.articles);
</script>
